import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { firestore, auth } from '../views/firebaseConfig';
import BusinessPostEdit from './BusinessPostEdit';

const BusinessPostManagerView = () => {
  const navigate = useNavigate();
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournamentId, setSelectedTournamentId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const currentUserID = auth.currentUser?.uid;
    if (!currentUserID) return;

    const q = query(
      collection(firestore, 'tournaments'),
      where('businessId', '==', currentUserID),
      where('status', 'in', ['active', 'inactive'])
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const fetched = querySnapshot.docs.map(doc => {
        const data = doc.data();
        const bookingMap = data.booking || {};
        return {
          id: doc.id,
          ...data,
          bookedUsersCount: Object.values(bookingMap).filter(s => s === 'booked').length,
          formattedDateTime: data.dateTime.toDate().toLocaleString()
        };
      });
      setTournaments(fetched);
    });

    return () => unsubscribe();
  }, []);

  const openEditor = (id) => {
    setSelectedTournamentId(id);
    setIsModalOpen(true);
  };

  const closeEditor = () => {
    setSelectedTournamentId(null);
    setIsModalOpen(false);
  };

  return (
    <div className="container py-4">
      {tournaments.length === 0 ? (
        <div className="text-center text-muted">No events found. Click the + to add a new one.</div>
      ) : (
        <div className="list-group">
          {tournaments.map(t => (
            <div key={t.id} className="list-group-item list-group-item-action mb-2">
              <div className="d-flex justify-content-between">
                <div onClick={() => openEditor(t.id)} style={{ cursor: 'pointer' }}>
                  <span className={`badge bg-${t.status === 'active' ? 'success' : 'secondary'} me-2`}>
                    {t.status.toUpperCase()}
                  </span>
                  <strong>{t.title}</strong>
                  <p className="mb-1 small text-muted">{t.description}</p>
                  <p className="mb-1"><strong>When:</strong> {t.formattedDateTime}</p>
                </div>
                <div className="text-end">
                  <div className="text-primary fw-bold mb-2">Bookings: {t.bookedUsersCount}</div>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => deleteDoc(doc(firestore, 'tournaments', t.id))}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal show={isModalOpen} onHide={closeEditor} centered size="lg">
      <Modal.Body className="bg-white text-dark p-4">
      {selectedTournamentId && (
            <BusinessPostEdit tournamentId={selectedTournamentId} onClose={closeEditor} />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BusinessPostManagerView;
